export function isTabVisible() {
  return !document.hidden;
}

export function onTabVisibilityChange(handlerFn) {
  if (handlerFn) document.addEventListener("visibilitychange", handlerFn);
  return () => document.removeEventListener("visibilitychange", handlerFn);
}
